"use strict";

define('rs/models/document.type',['rs/models/abstract'], function (AbstractModel) {
  var DocumentType = AbstractModel.extend({
    properties: ['activityDate', 'description', 'id', 'updateUserAuthId', 'version']
  }, {});
  return DocumentType;
});

